module.exports = __webpack_public_path__ + "static/company-about-hero-a0b3ccac5f542ca2f9e8d93c7820acf7.jpg";